import { render } from "./TabReturn.vue?vue&type=template&id=5f1f3c37"
import script from "./TabReturn.js?vue&type=script&lang=js"
export * from "./TabReturn.js?vue&type=script&lang=js"

import "./TabReturn.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__